import { CommonModule, NgFor } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import { Client, GuidDictionaryItem } from '../../../../../../../api/api-reference';
import { MultiSelectDropdownSearchComponent } from '../../../../multi-select-dropdown-search/multi-select-dropdown-search.component';
import { FilterPanelComponent } from '../../filter-panel.component';

export interface ScheduledDataFilterOutput {
  selectedAssetTypes: string[];
  areas: string[];
  regions: string[];
}

@Component({
  selector: 'app-scheduled-data-filter',
  standalone: true,
  imports: [CommonModule, NgFor, TranslateModule, FilterPanelComponent, MultiSelectDropdownSearchComponent],
  templateUrl: './scheduled-data-filter.component.html',
  styleUrl: './scheduled-data-filter.component.scss',
})
export class ScheduledDataFilterComponent implements OnInit {
  @Input() numberOfResults: number = 0;
  @Input() selectedAssetTypes: string[] = [];
  @Input() selectedAreas: string[] = [];
  @Input() selectedRegions: string[] = [];

  @Output() applied = new EventEmitter<ScheduledDataFilterOutput>();

  assetTypes: GuidDictionaryItem[] = [];
  draftAssetTypes: string[] = [];
  draftAreas: string[] = [];
  draftRegions: string[] = [];

  get activeFilterCount(): number {
    return this.selectedAssetTypes.length + this.selectedAreas.length + this.selectedRegions.length;
  }

  fetchAreas = () => this.client.getAllAreasForOptions();
  fetchRegions = () => this.client.getAllRegionsForOptions();

  constructor(private client: Client, private toastr: ToastrService) {}

  ngOnInit(): void {
    this.reset();
    this.client.getAllAssetTypesForOptions(undefined).subscribe({
      next: (res) => (this.assetTypes = res ?? []),
      error: (err) => this.toastr.error(err),
    });
  }

  isIn<T>(list: T[], item: T): boolean {
    return list.includes(item);
  }

  toggleGuid(list: string[], item: GuidDictionaryItem): string[] {
    const val = item.value!;
    return list.includes(val) ? list.filter((v) => v !== val) : [...list, val];
  }

  onAreaListReceived(list: string[]): void {
    this.draftAreas = list;
  }

  onRegionListReceived(list: string[]): void {
    this.draftRegions = list;
  }

  onApply(): void {
    this.applied.emit({
      selectedAssetTypes: this.draftAssetTypes,
      areas: this.draftAreas,
      regions: this.draftRegions,
    });
  }

  onCancel(): void {
    this.reset();
  }

  private reset(): void {
    this.draftAssetTypes = [...this.selectedAssetTypes];
    this.draftAreas = [...this.selectedAreas];
    this.draftRegions = [...this.selectedRegions];
  }
}
